<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <section id="Noprop" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 section-no-margin-bottom">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4 pl-0"></div>
      <div class="center col-4 text-center"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png"
          class="logo-image" alt="edit"></div>

      <div class="col-4 text-right">
        <div> <app-helpsection></app-helpsection></div>

      </div>
    </div>
  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <app-suppliertab></app-suppliertab>
    <div class="row m-0 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">SEARCH</h4>
      </div>

      <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2" *ngIf="showForConsult">
        <button type="button" class="btn btn-custom btn-blue btn-custom-lg float-right" (click)="setImportInput()"
          data-target="#openImportIpnModal" data-toggle="modal" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setImportInput())">
          Import IPN
        </button>
      </div>
    </div>

    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <label class="label-control">First name
        </label>
        <div class="search-input-container">
          <input type="text" class="form-control form-control-sm search-input-container search-input-field" [(ngModel)]="firstName"
            (keyup)="onItemKey($event)"
            (keydown)="resetOtherFields('firstName',$event)">
          <small class="search-close-btn search-close-button " title="Clear"><u
            (click)="clearFields('firstName')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('firstName'))">X</u></small>
        </div>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <label class="label-control">Last name
        </label>
        <div class="search-input-container">
          <input type="text" class="form-control form-control-sm search-input-field" [(ngModel)]="LastName"
            (keyup)="onItemKey($event)"
            (keydown)="resetOtherFields('lastName',$event)">
          <small class="search-close-btn search-close-button" title="Clear"><u
            (click)="clearFields('LastName')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('LastName'))">X</u></small>
        </div>
      </div>
    </div>

    <div class="row m-0 ml-3 align-center">
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
      <span class="px-2 font-weight-bold">OR</span>
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
    </div>

    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 pb-0 mb-0">
        <mat-label class="label-control">Identifier Type</mat-label>
        <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="identifierTypeModel"
          (selectionChange)="selectChangeHandler($event); restAlldatas($event)" panelClass="dropdown-panel"
          [disableOptionCentering]="true">
          <mat-option value="ipn">IPN</mat-option>
          <mat-option value="role">Role</mat-option>
          <mat-option value="email">E-Mail</mat-option>
        </mat-select>
      </div>

      <div *ngIf="identifierTypeModel === 'role'"
        class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 pb-0 mb-0">
        <mat-label class="label-control">Role Category Code<span class="element_astrick">*</span></mat-label>
        <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="roleCategory"
          (ngModelChange)="getRoleTypes(1, true)" (selectionChange)="onRoleCategorySelect($event)"
          panelClass="dropdown-panel" [disableOptionCentering]="true">
          <mat-option value="group contact">Group Contacts</mat-option>
          <mat-option value="company contact">Company Contacts</mat-option>
          <mat-option value="site contact">Site Contacts</mat-option>
        </mat-select>
        <span class="error-text" *ngIf="RoleCategoryError">Please select Role Category Code</span>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mt-3">
        <label class="label-control">Identifier Value
        </label>
        <div class="form-control form-control-sm matformheight identifier-value-container" *ngIf="!roleDropdown">
          <form class="identifier-value-form">
            <mat-form-field class="identifier-value-field">
              <input class="identifier-input-with-clear" matInput aria-label="State" (keyup)="onItemKey($event)"
                (keydown)="resetOtherFields('ipn',$event)" [matAutocomplete]="auto" [formControl]="delayIpnInput">
              <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete autocomplete-display-block">
                <ng-container *ngIf="ipnModelDropDown.length > 0 && enterKey; else noResults">
                  <mat-option class="autocomplete-option-full-width" *ngFor="let value of ipnModelDropDown"
                    (click)="onIdentivalueSelect(value,'id')" [value]="value">
                    <span>{{ value }}</span>
                  </mat-option>
                </ng-container>
                <ng-template #noResults>
                  <mat-option class="noResults" disabled *ngIf="ipnModel.length >= 5 && !autoload && enterKey">
                    <span>No results</span>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
            </mat-form-field>
            <small class="identifier-close-button" title="Clear" *ngIf="!autoload"><u (click)="clearFields('ipn')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('ipn'))">X</u></small>
            <small class="identifier-close-button" *ngIf="autoload"><img src="assets/images/loading.gif"
                class="loadingheight" alt="Updating..."></small>
          </form>
        </div>

        <div class="pr-4 m-0" *ngIf="roleDropdown">
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="selectedRole"
            (selectionChange)="selectedRoleChange($event)" (keydown)="resetOtherFields('role',$event)"
            panelClass="dropdown-panel" [disableOptionCentering]="true">
            <mat-option *ngFor="let rolelist of PersonRoleSelectOp"
              value="{{rolelist.roleTypeCode}}">{{rolelist.roleTypeLabel}}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <div class="row m-0 align-center">
      <div class="form-group col col-6 col-sm-9 col-md-6 col-lg-6 col-xl-6">
      </div>

      <div class="form-group col col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-right">
        <button type="button" class="btn btn-custom btn-link" (click)="clearFields('All')"> Clear All </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue" (click)="ValidateMandarotyFields()"> Search
        </button>
      </div>
    </div>

  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <div class="row m-0 pt-3 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">RESULTS <span
            *ngIf="loadData==true && data && data.length>=0">({{pager?.totalItems}}{{displayType}})</span></h4>
      </div>

      <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
        <button type="button" class="btn btn-custom btn-blue float-right export-button-width" *ngIf="superUserShow">
          <mat-icon svgIcon="download" aria-hidden="true" class="thick-icon export-icon-size"></mat-icon><span class="float-right"> Export </span>
        </button>
      </div>
    </div>

    <div class="row m-0">
      <div class="table-responsive mt-3">
        <div [ngClass]="{ 'fixTableHead' :loadData == true, 'fixTableFoot' :loadData == true }">
          <table class="table table-sm m-0">
            <thead>
              <tr>
                <th class="sortDecorationunderline th-sortable-left"
                  (click)="sort('personFirstName')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('personFirstName'))">First Name</th>
                <th class="sortDecorationunderline th-sortable-left" (click)="sort('personLastName')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('personLastName'))">
                  Last Name</th>
                <th class="th-left-narrow">E-mail</th>
                <th class="th-left-narrow">IPN</th>
                <th class="th-left-medium">Site / Company / Group</th>
                <th class="th-left-small">Role</th>
                <th class="th-minimal-width"></th>
              </tr>
            </thead>

            <tbody *ngIf="loadData==true && userRoleData && userRoleData.length>=0" #customLoadingTemplate>
              <tr *ngFor="let cmData of userRoleData | orderBy: key:reverse;let i=index">
                <td>{{cmData ? cmData.personFirstName : ''}}</td>
                <td class="font-weight-bold label-darkblue td-cursor-pointer" data-toggle="modal" data-target="#openContactDetails"
                  *ngIf="superusershow==true"
                  (click)="editContactFn(cmData,emailData[cmData.personRowId],ipnData[cmData.personRowId],companySupplierData[userCompanyData[cmData.personRowId][cmData.rowId].companyId],roleTypeDesc[cmData.roleTypeCode].roleTypeLabel)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (editContactFn(cmData,emailData[cmData.personRowId],ipnData[cmData.personRowId],companySupplierData[userCompanyData[cmData.personRowId][cmData.rowId].companyId],roleTypeDesc[cmData.roleTypeCode].roleTypeLabel))">
                  {{cmData ? cmData.personLastName : ''}}</td>
                <td *ngIf="roleVariableHide || showBuyerProfile || roleIsManager==true || showForConsult == true ">
                  {{cmData ? cmData.personLastName : ''}}</td>
                <td>{{emailData[cmData.personRowId] ? emailData[cmData.personRowId].summary : ''}}</td>
                <td>{{ipnData[cmData.personRowId] && ipnData[cmData.personRowId].ipnnotpresent == false ?
                  ipnData[cmData.personRowId].loginId : ''}}</td>
                <td class="font-weight-bold label-darkblue">
                  <ng-container *ngIf="roleCategory=='' || roleCategory=='company contact'">
                    <span
                      *ngIf="companySupplierData.length > 0 && userCompanyData.length > 0 && userCompanyData[cmData.personRowId]">
                      <span *ngIf="userCompanyData[cmData.personRowId][cmData.rowId]">
                        <a class="label-darkblue"
                          [routerLink]="['/company-details',userCompanyData[cmData.personRowId][cmData.rowId].companyId]">{{companySupplierData[userCompanyData[cmData.personRowId][cmData.rowId].companyId]
                          ? companySupplierData[userCompanyData[cmData.personRowId][cmData.rowId].companyId].legalName :
                          ''}}</a>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="roleCategory=='' || roleCategory=='group contact'">
                    <span
                      *ngIf="contactGroupData.length > 0 && userGroupData.length > 0 && userGroupData[cmData.personRowId]">
                      <span *ngIf="userGroupData[cmData.personRowId][cmData.rowId]">
                        <a class="label-darkblue"
                          [routerLink]="['/supplier-group-details',userGroupData[cmData.personRowId][cmData.rowId].groupId]">{{contactGroupData[userGroupData[cmData.personRowId][cmData.rowId].groupId]
                          ? contactGroupData[userGroupData[cmData.personRowId][cmData.rowId].groupId].groupName :
                          ''}}</a>
                      </span>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="roleCategory=='' || roleCategory=='site contact'">
                    <span
                      *ngIf="contactSiteData.length > 0 && userSiteData.length > 0 && userSiteData[cmData.personRowId]">
                      <span *ngIf="userSiteData[cmData.personRowId][cmData.rowId]">
                        <a class="label-darkblue"
                          [routerLink]="['/site-details',userSiteData[cmData.personRowId][cmData.rowId].siteId,userSiteData[cmData.personRowId][cmData.rowId].companyId]">{{contactSiteData[userSiteData[cmData.personRowId][cmData.rowId].siteId]
                          ? contactSiteData[userSiteData[cmData.personRowId][cmData.rowId].siteId].siteName : '' }}</a>
                      </span>
                    </span>
                  </ng-container>


                </td>
                <td>
                  {{roleTypeDesc[cmData.roleTypeCode] ? roleTypeDesc[cmData.roleTypeCode].roleTypeLabel : ''}}
                </td>
                <td *ngIf="superusershow == true">
                  <mat-icon class="edit edit-icon-size" svgIcon="edit" alt="edit" data-toggle="modal" data-target="#EditCmpConRole"
                    (click)="editContactFn(cmData,emailData[cmData.personRowId],ipnData[cmData.personRowId],companySupplierData[userCompanyData[cmData.personRowId][cmData.rowId].companyId],roleTypeDesc[cmData.roleTypeCode])" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (editContactFn(cmData,emailData[cmData.personRowId],ipnData[cmData.personRowId],companySupplierData[userCompanyData[cmData.personRowId][cmData.rowId].companyId],roleTypeDesc[cmData.roleTypeCode]))">
                  </mat-icon>
                </td>
              </tr>
            </tbody>

            <tbody *ngIf="loadData == false" #customLoadingTemplate>
              <tr>
                <td colspan="8" class="font-weight-bold label-darkblue text-center"> No Results</td>
              </tr>
            </tbody>

            <tfoot *ngIf="PageTotalLength >maxRecorePage ">
              <tr>
                <td colspan="8">
                  <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="selectedCIddentifier2('','','',1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',1,'cked'))">First</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="selectedCIddentifier2('','','',pager.currentPage - 1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',pager.currentPage - 1,'cked'))">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                      <a (click)="selectedCIddentifier2('','','',page,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',page,'cked'))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="selectedCIddentifier2('','','',pager.currentPage + 1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',pager.currentPage + 1,'cked'))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="selectedCIddentifier2('','','',pager.totalPages,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',pager.totalPages,'cked'))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tfoot>
            <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
          </table>
        </div>
      </div>
    </div>
  </section>
</div>

<div class="modal fade" id="openImportIpnModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Import IPN
          <button type="button" class="close" id="closeImportIpn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control font-weight-bold">IPN
            </label>
            <input type="text" id="EditBvdIdInput" class="form-control form-control-sm" [(ngModel)]="importIpnModel">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear"
                (click)="resetIpnInput()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetIpnInput())">×</span></span>
            <span class="error-text" *ngIf="importIpnInputError==true">Please enter the value.</span>
            <span class="error-text" *ngIf="importIpnInvalidError==true">{{importInvalidText}}</span>
          </div>
        </section>

        <section class="row m-0 bg-white no-shadow" *ngIf="superUserShow==true || roleVariableHide==true">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control font-weight-bold">Upload TXT File
            </label>
            <input #inputUpload id="file" (change)="changeListener($event)" type="file" accept=".txt" />
            <span class="error-text-block" *ngIf="fileIsEmpty==true">File has no IPN to import!</span>
            <span class="error-text-block" *ngIf="uploadDocError">Only TXT files are accepted.</span>
          </div>
        </section>

        <span class="error-text" *ngIf="importIpnByEitherOne==true">Please Import Ipn By Either One Method!</span>
      </div>

      <div class="modal-footer border-0 row text-right">
        <section class="bg-white no-shadow col m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-md btn-blue" [disabled]="disableIpnBtn"
            (click)="ImportIPN()">
            Import
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditCmpConRole" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Edit Company Role
          <button type="button" class="close" id="closeEditCmpConRole" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <div class="mb-3 pl-3"> <span class="label-bold">Company : </span> {{ contactCompany ? contactCompany :
          '' }} </div>

        <div class="mb-3 pl-3"> <span class="label-bold">Name : </span> {{ contactFirstName ? contactFirstName :
          '' }} {{ contactLastName ? contactLastName : '' }}</div>

        <div class="mb-3 pl-3"> <span class="label-bold">Email : </span> {{ contactEmail ? contactEmail : '' }}
        </div>

        <div class="mb-3 pl-3" *ngIf="contactIpn!='' "> <span class="label-bold">IPN : </span> {{ contactIpn ?
          contactIpn : '' }} </div>


        <section class="row m-0 bg-white no-shadow">

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12">
            <mat-label class="label-control label-bold">Role
            </mat-label>
            <mat-select class="form-control form-control-sm dropdown-select" [disabled]="disableContactRoleEdit==true"
              [(ngModel)]="contactRole" (change)="CmpCntRoleSelected($event)" panelClass="dropdown-panel">
              <ng-container *ngIf="PersonRoleSelectOp.length>0"></ng-container>
              <mat-option *ngFor="let pRole of PersonRoleSelectOp"
                value="{{pRole.rowId}}">{{pRole.roleTypeLabel}}</mat-option>
            </mat-select>
            <span class="error-text" *ngIf="CmpConRoleError==true">Please Select the Role.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="addEditContactDetails()"
            [disabled]="disableEditContactSaveBtn==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon> <span class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openContactDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Contact
          <button type="button" class="close" id="closeContactDetails" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">

        <div class="mb-3 pl-3"> <span class="label-bold">Name : </span> {{ contactFirstName ? contactFirstName :
          '' }} {{ contactLastName ? contactLastName : '' }}
          <span class="edit ml-2" *ngIf="contactIpn=='' "> <mat-icon svgIcon="edit" alt="edit"></mat-icon> </span>
        </div>

        <div class="mb-3 pl-3"> <span class="label-bold">Email : </span> {{ contactEmail ? contactEmail : '' }}
        </div>

        <div class="mb-3 pl-3"> <span class="label-bold">IPN : </span> {{ contactIpn ? contactIpn : '' }} </div>

        <div class="mb-3 pl-3"> <span class="label-bold">Cellphone : </span> {{ contactCellphone ?
          contactCellphone : '' }}
          <span class="edit ml-2" *ngIf="contactIpn=='' "> <mat-icon svgIcon="edit" alt="edit"></mat-icon> </span>
        </div>

        <div class="mb-3 pl-3"> <span class="label-bold">Phone : </span> {{ contactPhone ? contactPhone : '' }}
          <span class="edit ml-2" *ngIf="contactIpn=='' "> <mat-icon svgIcon="edit" alt="edit"></mat-icon> </span>
        </div>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red delete-button-red"
            data-toggle="modal" data-target="#DeleteContact">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon> <span class="float-right">Delete</span>
          </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon> <span class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="DeleteContact" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Delete Contact
          <button type="button" class="close" id="closeDelCont" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control label-delete-confirm"> Do you want to
              delete this contact?</label>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue delete-button-background"
            (click)="delContact()">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon> <span class="float-right">Delete</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openEditNameFields" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content modal-content-offset">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Edit Company Contact
          <button type="button" class="close" id="closeopenEditNameFields" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1 row">
        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <label class="label-control">First Name</label>
          <div>
            <input class="form-control form-control-sm" [(ngModel)]="contactFirstName"  type="text"
              (keyup)="contactEmptyCheck('contactFirstName')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <span class="ng-clear ng-clear-white-bg"
                (click)="resetCmpContact('contactFirstName')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetCmpContact('contactFirstName'))">×</span>
            </span>
            <span class="error-text" *ngIf="contactFirstNameError==true">Please Enter First name</span>
          </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <label class="label-control">Last Name</label>
          <div>
            <input class="form-control form-control-sm" [(ngModel)]="contactLastName"  type="text"
              (keyup)="contactEmptyCheck('contactLastName')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <span class="ng-clear ng-clear-white-bg"
                (click)="resetCmpContact('contactLastName')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetCmpContact('contactLastName'))">×</span>
            </span>
            <span class="error-text" *ngIf="contactLastNameError==true">Please Enter Last name</span>
          </div>
        </div>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" (click)="resetNameValues()"> Cancel
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="addEditContactDetails()"
            [disabled]="disableEditContactSaveBtn==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon> <span class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showImportIpnProcess" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Import IPN From The File
          <button type="button" class="close" id="closeImportIpnProcess" #closeBtn data-dismiss="modal"
            aria-label="Close" (click)="clearImportLocalStorage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="showDownloadLog==false">
              <div class="mb-2" *ngIf="currentIpnBeingProcessed">
                <span class="font-weight-bold">Processing IPN: </span>
                <span class="label-darkblue">{{currentIpnBeingProcessed}}</span>
              </div>
              <div class="mb-3" *ngIf="currentIpnBeingProcessed">
                <span class="font-weight-bold">Progress: </span><span class="importProgress">Importing ({{(((noOfIpnsImported + (currentIpnApiCalls / estimatedApiCallsPerIpn)) / totalIpnsToImport) * 100).toFixed(1)}}%)</span>
                <div class="progress progress-custom">
                  <div class="progress-bar" role="progressbar progressbar-custom"
                    [style.width.%]="((noOfIpnsImported + (currentIpnApiCalls / estimatedApiCallsPerIpn)) / totalIpnsToImport) * 100"
                    [attr.aria-valuenow]="noOfIpnsImported"
                    [attr.aria-valuemin]="0" [attr.aria-valuemax]="totalIpnsToImport">
                  </div>
                </div>
              </div>

              <!-- Enhanced Error Display -->
              <div class="mb-3" *ngIf="currentErrorType === 'warning'">
                <div class="d-flex align-items-start">
                  <div>
                    <strong>Warning:</strong> {{currentErrorMessage}}
                    <div *ngIf="errorDetails" class="mt-1 text-size-small">
                      <small>{{errorDetails}}</small>
                    </div>
                    <div class="mt-1 text-size-small">
                      <small><em>Continuing with next IPN...</em></small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3" *ngIf="currentErrorType === 'critical'">
                <div class="d-flex align-items-start">
                  <div>
                    <strong>Critical Error:</strong> {{currentErrorMessage}}
                    <div *ngIf="errorDetails" class="mt-2 text-size-small">
                      <strong>Details:</strong> {{errorDetails}}
                    </div>
                    <div class="mt-2">
                      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="retryImport()">
                        Retry Current IPN
                      </button>
                      <button type="button" class="btn btn-custom btn-custom-sm btn-link ml-2"
                        (click)="skipAndContinue()">
                        Skip & Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-2" *ngIf="lastSuccessfulIpn && currentErrorType === 'none'">
                <div class="d-flex align-items-start">
                  <div class="text-size-medium">
                    Last successful IPN: <strong>{{lastSuccessfulIpn}}</strong>
                  </div>
                </div>
              </div>

              <span [innerHtml]="ipnTextDisplay">
              </span>
            </div>
            <div class="py-2" *ngIf="showDownloadLog==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFile()">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForIpnInError}}</span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUpload}}</span>
              <span [innerHtml]="ipnTextDisplay" *ngIf="loadingNoOfIpnsImported==true"></span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" (click)="clearImportLocalStorage()"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showErrorRefresh" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Import IPN From The File
          <button type="button" class="close" id="closeshowErrorRefresh" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">
              <span class="label-darkblue font-weight-bold">Error occured, please click on Refresh button to reload the
                page!</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="refreshPage()">
            <mat-icon svgIcon="refresh" class="refresh-icon-size"></mat-icon> <span class="float-right"> Refresh </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="hidden">
  <table id="excelTableLog">
    <thead>
      <tr>
        <th>IPN In Error</th>
        <th>Error Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexIpn of logFileArrayOfIpns">
        <td>
          {{indexIpn['ipn'] ? indexIpn['ipn'] : '-'}}
        </td>
        <td>
          {{indexIpn['error'] ? indexIpn['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="hidden">
  <button id="btnForImportIpnByFile" data-target="#showImportIpnProcess" data-toggle="modal"></button>
  <button id="btnForErrorRefresh" data-target="#showErrorRefresh" data-toggle="modal"></button>
</div>